import { useState } from "react";
import { Popover } from "@bookingcom/bui-react";
import { DateRangePickerTrigger } from "./DateRangePickerTrigger";
import { DateRangePickerContent } from "./DateRangePickerContent";
import type { DateRange, RecentPeriod } from "../../types/date";

export type DateRangePickerProps = {
  dateRange: DateRange;
  quickSelect?: RecentPeriod;
  onSubmit: (dateRange: DateRange, quickSelect?: RecentPeriod) => void;
};

export const DateRangePicker = ({ onSubmit, ...props }: DateRangePickerProps) => {
  const [active, setActive] = useState(false);

  const handleSubmit = (dateRange: DateRange, quickSelect?: RecentPeriod) => {
    onSubmit(dateRange, quickSelect);
    setActive(false);
  };

  return (
    <Popover
      closeAriaLabel="Close popover"
      position="bottom-start"
      forcePosition={true}
      hideArrow={true}
      hideClose={true}
      keepMounted={false}
      size="stretch"
      fill
      active={active}
      onOpen={() => setActive(true)}
      onClose={() => setActive(false)}
    >
      <Popover.Trigger>
        {(attributes) => <DateRangePickerTrigger dateRange={props.dateRange} attributes={attributes} />}
      </Popover.Trigger>
      <Popover.Content>
        <DateRangePickerContent dateRange={props.dateRange} quickSelect={props.quickSelect} onSubmit={handleSubmit} />
      </Popover.Content>
    </Popover>
  );
};
